import {documentReady} from "../Utility/utils";
import { nextTick } from "petite-vue";

// shows thumbnails on hover
let articles = document.querySelectorAll(".articles-grid__container article");

articles.forEach(function (article, index) {
  let thumbnail = article.querySelector(".articles-grid__container__article__post-thumbnail");

  if (typeof thumbnail != "undefined" && thumbnail != null) {
    // shows thumbnail
    article.onmouseenter = function (event) {
      this.classList.add("active");
      // console.log('mouse enter');

      // mouse move
      this.onmousemove = function (e) {
        // article div dimensions
        var square = this.getBoundingClientRect();
        var squareX = square.x;
        var squareY = square.y;
        var squareWidth = square.width;
        var squareHeight = square.height;

        // mouse coordinates
        var mouseX = e.clientX;
        var mouseY = e.clientY;

        // sets thumbnail position based on mouse coordinates
        thumbnail.style.top = -squareY + mouseY - (squareHeight / 2 - 15) + "px";
        thumbnail.style.left = -squareX + mouseX - (squareWidth / 2 - 15) + "px";
      };

      // hides thumbnail
      this.onmouseleave = function (event) {
        this.classList.remove("active");
        // console.log('mouse leave');
      };
    };
  }
});

documentReady((event) => {
  const filter = document.querySelector('.articles-grid__filter');
  if(!!filter){
    // Post Type Filter Dropdown
    const postTypeFilter = document.querySelector('.filter_drop_down');
    if(!!postTypeFilter){
      const trigger = postTypeFilter.querySelector('button');
      const list = postTypeFilter.querySelector('ul');

      trigger.addEventListener('click', function(){
        if(list.classList.contains('active')){
          list.classList.remove('active');
          list.setAttribute('aria-hidden', 'true');
        }
        else {
          list.classList.add('active');
          list.setAttribute('aria-hidden', 'false');
        }
      });

      const options = list.querySelectorAll('a');
      options.forEach(option => {
        option.addEventListener('click', function(){
          list.classList.remove('active');
          list.setAttribute('aria-hidden', 'true');
        });
      });
    }

    // Remove focus after clicking on filter item
    const filterItems = filter.querySelectorAll('a, button');
    filterItems.forEach( item => {
      item.addEventListener('click', function(){
        item.blur();
      });
    });
  }
});

// gets all posts
export const postFeed = ({ posts, toDisplay }) => {
  const allPosts = posts;
  const postsToDisplay = toDisplay || 12;

  return {
    allPosts,
    chosenCategory: "",
    chosenPostType: "All Post Types",
    showError: false,
    postsToDisplay,
    async offsetClasses() {
      await nextTick();
      const cards = document.querySelectorAll('.articles-grid__container__article');

      // we'll loop through the posts and get any card that aligns with the second column.
      let secondColLeft = 0;
      for(card in cards){
        const currentCard = parseInt(card);
        if(typeof currentCard === 'number' && currentCard > 0){
          const cardLeft = cards[card].offsetLeft;

          // if we're on the second card but the left position is still 0,
          // then we're in a one column view and can quit.
          if(currentCard == 1 && cardLeft == 0){
            return;
          }

          // We've determined there is more than one column.
          // Now check if this card is in the second column or not, and set classes accordingly
          if(currentCard === 1){
            secondColLeft = cardLeft;
          }

          // If there's only one column, remove any .offsetCard classes
          if(secondColLeft == 0){
            cards[card].classList.remove('offsetCard');
          }
          // Else, we have multiple columns
          else {
            if(cardLeft == secondColLeft){
              cards[card].classList.add('offsetCard');
            }
            else {
              cards[card].classList.remove('offsetCard');
            }
          }
        }
      }
    },
    get sortedPosts() {
      return [...this.researchPosts, ...this.clinicalPosts, ...this.educationPosts];
    },
    get introPost() {
      return this.allPosts.filter((l) => l.categories.includes('Letters') && l.categories.length < 2 );
    },
    get researchPosts(){
      const letter = this.allPosts.filter((l) => l.categories.includes('Letters') && l.categories.includes('Research'));
      const feature = this.allPosts.filter((l) => l.categories.includes('Research') && l.postType == 'Featured Stories');
      const research = this.allPosts.filter((l) => l.categories.includes('Research') && !l.categories.includes('Letters') && l.postType !== 'Featured Stories');
      return [...letter, ...feature, ...research];
    },
    get clinicalPosts(){
      const letter = this.allPosts.filter((l) => l.categories.includes('Letters') && l.categories.includes('Clinical'));
      const feature = this.allPosts.filter((l) => l.categories.includes('Clinical') && l.postType == 'Featured Stories');
      const clinical = this.allPosts.filter((l) => l.categories.includes('Clinical') && !l.categories.includes('Letters') && l.postType !== 'Featured Stories');
      return [...letter, ...feature, ...clinical];
    },
    get educationPosts(){
      const letter = this.allPosts.filter((l) => l.categories.includes('Letters') && l.categories.includes('Education'));
      const feature = this.allPosts.filter((l) => l.categories.includes('Education') && l.postType == 'Featured Stories');
      const education = this.allPosts.filter((l) => l.categories.includes('Education') && !l.categories.includes('Letters') && l.postType !== 'Featured Stories');
      return [...letter, ...feature, ...education];
    },
    get filteredItems() {
      const hasCategoryFilter = this.chosenCategory === "" || this.chosenCategory === "All" ? false : true;
      const hasPostTypeFilter = this.chosenPostType === "" || this.chosenPostType === "All Post Types" ? false : true;
      // let posts = this.allPosts;
      let posts = this.sortedPosts;

      //no filters? show them all
      if (!hasCategoryFilter && !hasPostTypeFilter) {
        this.offsetClasses();
        return posts;
      }

      if(hasCategoryFilter){
        posts = posts.filter((l) => l.categories.includes(this.chosenCategory));
      }

      if(hasPostTypeFilter){
        posts = posts.filter((l) => l.postType.includes(this.chosenPostType));
      }

      this.showError = posts.length < 1 ? true : false;

      this.offsetClasses();

      return posts;
    },
    get pagedItems() {
      return this.filteredItems.slice(0, this.postsToDisplay);
    },
    get windowResizeEvents() {
      window.addEventListener('resize', () =>{
        // Ensure cards have the right offset classes
        setTimeout(() => {
          this.offsetClasses();
        }, 100);
      });
    }
  };
};
